import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import PrivateRoute from "./PrivateRoute";

import Navbar from "./pages/site/Navbar";
import Home from "./pages/site/Home";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import Catalogue from "./pages/site/Catalogue";
import Product from "./pages/site/Product";
import Profile from "./pages/auth/Profile";
import Play from "./pages/game/Play";
import WaitingRoom from "./pages/game/WaitingRoom";
import PlayEntry from "./pages/game/PlayEntry";
import Game from "./pages/game/Game";
import Scoreboard from "./pages/scoreboards/Scoreboard";
import Pricing from "./pages/site/Pricing";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import LegalMentions from "./components/legal/LegalMentions";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import Footer from "./pages/site/Footer";
import CompanyScoreboardBySessionCode from "./pages/scoreboards/CompanyScoreboardBySessionCode";
import ScoreboardsHub from "./pages/scoreboards/ScoreboardsHub";
import Guide from "./pages/site/Guide";
import { ToastProvider } from "./components/ui/Toast";
import { ConfirmProvider } from "./components/ui/Confirm";
import { getOrigamiGameStats } from "./games/origami/config/scoreboardStats";
import AdminSessionDetail from "./admin/AdminSessionDetail";
import AdminAffiliateDetail from "./pages/admin/AdminAffiliateDetail";
import AffiliateActivation from "./pages/AffiliateActivation";
import AffiliateLogin from "./pages/AffiliateLogin";
import AffiliateDashboard from "./pages/AffiliateDashboard";
import AffiliateForgotPassword from "./pages/AffiliateForgotPassword";
import AffiliateResetPassword from "./pages/AffiliateResetPassword";
import BecomePartner from "./pages/BecomePartner";
import Roadmap from "./pages/Roadmap";

// Layout principal (a accès à useLocation)
function AppLayout() {
  const location = useLocation();

  // on considère qu'une partie est "en cours" sur ces routes :
  const isInGame =
    location.pathname.startsWith("/game/") ||
    location.pathname.startsWith("/scoreboard/");

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* On masque la navbar pendant le jeu */}
      {!isInGame && <Navbar />}

      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />

          {/* Auth entreprises */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          <Route
            path="/catalogue"
            element={
              <Catalogue />
            }
          />
          <Route
            path="/catalogue/:id"
            element={
              <Product />
            }
          />
          <Route path="/offres" element={<Pricing />} />

          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />

          {/* Joueurs */}
          <Route path="/play" element={<PlayEntry />} />
          <Route path="/play/:code" element={<Play />} />
          <Route path="/waiting/:code" element={<WaitingRoom />} />
          <Route path="/game/:code" element={<Game />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/sessions/:code" element={<AdminSessionDetail />} />
          <Route path="/admin/affiliates/:id" element={<AdminAffiliateDetail />} />

          {/* Affiliation */}
          <Route path="/affilie/activation/:token" element={<AffiliateActivation />} />
          <Route path="/affilie/login" element={<AffiliateLogin />} />
          <Route path="/affilie/dashboard" element={<AffiliateDashboard />} />
          <Route path="/affilie/forgot-password" element={<AffiliateForgotPassword />} />
          <Route path="/affilie/reset-password/:token" element={<AffiliateResetPassword />} />
          <Route path="/devenir-partenaire" element={<BecomePartner />} />

          {/* autres */}
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/mentions-legales" element={<LegalMentions />} />
          <Route
            path="/politique-confidentialite"
            element={<PrivacyPolicy />}
          />
          <Route path="/scoreboards" element={<ScoreboardsHub />} />
          <Route path="/scoreboards/company/by-session/:code" element={<CompanyScoreboardBySessionCode />} />
          <Route path="/scoreboard/:code" element={<Scoreboard getGameStats={getOrigamiGameStats} />} />
          <Route path="/guide" element={<Guide />} />
        </Routes>
      </main>

      {/* On masque aussi le footer pendant le jeu */}
      {!isInGame && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ToastProvider>
          <ConfirmProvider>
            <AppLayout />
          </ConfirmProvider>
        </ToastProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
